/** @format */

import React, { /* useState, */ useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { useTheme } from '@mui/styles';
import { useStylesSkeleton } from './style';

import { useMediaQuery } from '@mui/material';

// import { Sidebar, Topbar, Footer } from "./components";

import { useUser, useUserDispatcher /* useBusinessDispatcher */ } from 'hooks';
import { AuthService } from 'components/Auth';
// import MainServices from './MainServices';

const Skeleton = (props) => {
  const { children } = props;

  const user = useUser();
  const setUser = useUserDispatcher();
  // const setBusinessDispatcher = useBusinessDispatcher();

  const classes = useStylesSkeleton();
  const theme = useTheme();
  const isDesktop =
    useMediaQuery(theme.breakpoints.up('lg'), {
      defaultMatches: true,
    }) && user;

  useEffect(() => {
    if (AuthService.isAuthenticated()) {
      setUser(true);
    }
  }, []);
  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop,
      })}
    >
      {children}
    </div>
  );
};

Skeleton.propTypes = {
  children: PropTypes.node,
};

export default Skeleton;
